import { Component } from '@angular/core';

@Component({
    selector: 'wci-imprint',
    imports: [],
    template: `
        <div
            class="section-padding-vertical-md lg:section-padding-vertical-lg w-full flex flex-col gap-large items-center">
            <h1 class="text-center">Impressum</h1>

            <ul class="mx-auto mt-8 list-none">
                <li class="text-xl font-medium text-center">WeCodeIt OG</li>
                <li class="text-center">Hauptstraße 65</li>
                <li class="text-center">7023 Zemendorf</li>
                <li class="text-center">
                    Tel:
                    <a href="tel:+436603878395" class="text-primary-base hover:text-primary-darken"
                        >+43 660 3878395</a
                    >
                </li>
                <li class="text-center">
                    E-Mail:
                    <a
                        href="mailto:hello@wecodeit.at"
                        class="text-primary-base hover:text-primary-darken"
                        >hello&#64;wecodeit.at</a
                    >
                </li>
            </ul>

            <div class="flex flex-col gap-6 mt-4">
                <div class="flex flex-col items-center">
                    <label class="text-lg font-medium text-center">Firmenbuchnummer</label>
                    <label class="text-base text-center">FN 579483 g</label>
                </div>

                <div class="flex flex-col items-center">
                    <label class="text-lg font-medium text-center"
                        >Umsatzsteueridentifikationsnummer</label
                    >
                    <label class="text-base text-center">ATU 78263157</label>
                </div>
            </div>
        </div>
    `,
    styles: ``,
})
export class ImprintComponent {}
